import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PersonaContext } from "../context/PersonaContext";
import Header from "../components/Header";
import LoadingSpinner from "../components/LoadingSpinner";
import { createPersona, retryApiCall } from "../services/api";

const LoadingPage = () => {
  const navigate = useNavigate();
  const {
    selectedDataset,
    selectedDatasetName,
    selectedDatasetPath,
    selectedTopics,
    selectedQuestions,
    selectedEthnicities,
    selectedLocation,
  } = useContext(PersonaContext);
  const [loadingText, setLoadingText] = useState("Starting process...");
  const [error, setError] = useState("");

  const createPersonaRequest = async () => {
    const requestData = {
      dataset: selectedDatasetName,
      dataset_path: selectedDatasetPath,
      question_ids: selectedQuestions,
      ethnicity: selectedEthnicities,
      location: selectedLocation,
    };

    try {
      setLoadingText("Preprocessing data...");
      const response = await retryApiCall(createPersona, [requestData]);
      setLoadingText("Training model...");
      setTimeout(() => {
        setLoadingText("Finalizing results...");
      }, 2000);

      setTimeout(() => {
        navigate("/result", { state: { personaData: response } });
      }, 4000);
    } catch (error) {
      console.log(error);
      setError("Failed to create persona");
    }
  };

  useEffect(() => {
    createPersonaRequest();
  }, [
    navigate,
    selectedDataset,
    selectedTopics,
    selectedQuestions,
    selectedEthnicities,
    selectedLocation,
  ]);

  return (
    <div className="loading-page">
      <Header />
      <div className="loading-content">
        <LoadingSpinner />
        {error ? (
          <div>
            <p>{error}</p>
            <button onClick={createPersonaRequest} className="retry-button">
              Try Again
            </button>
          </div>
        ) : (
          <p>{loadingText}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingPage;
